import { render, staticRenderFns } from "./AnnouncementClose.html?vue&type=template&id=e320236c&scoped=true&"
import script from "./AnnouncementClose.vue?vue&type=script&lang=js&"
export * from "./AnnouncementClose.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementClose.scss?vue&type=style&index=0&id=e320236c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e320236c",
  null
  
)

export default component.exports